import React, { memo, useCallback } from 'react'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import LOG from '../../logging/Logger'

const SettingsSectionHeader = memo(({ changeHandler, title, value }) => {
  LOG.debug('Render: SettingsSectionHeader')

  const handleChange = useCallback(
    event => {
      changeHandler(event, value)
    },
    [changeHandler, value]
  )

  return (
    <Box
      component='span'
      display='block'
      p={1}
      m={1}
      bgcolor='background.paper'
    >
      <Link href='#' onClick={handleChange} value={value}>
        {title}
      </Link>
    </Box>
  )
})

export default SettingsSectionHeader
